import { makeAutoObservable } from "mobx";
import { OtpDeliveryRequest } from "core/services/cef/otp.service";
import { EncryptedCustomerResponse, } from "core/services/cef/permission.service.types";

export type SendOtpTo = OtpDeliveryRequest & {
    maskedValue: string
}

class LinkUpStore {
    result: EncryptedCustomerResponse | undefined;
    accounts: Array<any> = [];
    sendOtpTo: SendOtpTo | undefined;
    otpValue = "";
    deliveryOptions: Array<any> = [];
    otpKey = new Date().getTime().toString();
    displayMode = 0;
    showResentMessage = false;
    otpErrorMessage: string | undefined;
    isSearching = false;

    constructor() {
        makeAutoObservable(this);
    }

    updateAccounts(value: any) {
        this.accounts = value;
    }

    updateResult(value: EncryptedCustomerResponse) {
        this.result = value;
    }

    updateSendOtpTo(value: SendOtpTo) {
        this.sendOtpTo = value;
    }

    updateDeliveryOptions(value: Array<any>) {
        this.deliveryOptions = value;
    }

    updateOtpValue(value: string) {
        this.otpValue = value;
    }

    updateOtpErrorMessage(value: string | undefined) {
        this.otpErrorMessage = value;
    }

    updateDisplayMode(value: number) {
        this.displayMode = value;
    }

    updateShowResentMessage(value: boolean) {
        this.showResentMessage = value;
    }

    updateIsSearching(value: boolean) {
        this.isSearching = value;
    }

    reset() {
        this.accounts = [];
        this.sendOtpTo = undefined;
        this.otpValue = "";
    }
}

export default LinkUpStore;
